import { render, staticRenderFns } from "./DivideUnstressedVowels.vue?vue&type=template&id=57b0e905&lang=pug&"
import script from "./DivideUnstressedVowels.vue?vue&type=script&lang=js&"
export * from "./DivideUnstressedVowels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports